import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { getYearOptions } from '../../../services/dateServices';
import { Link } from 'react-router-dom';
import Api from '../../../../../Global/Modules/Api'

const FETCH_URL = "api/educations/teachershipadmin"

class Docentschap extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            errors: {}
        }
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        const deita = event.target.elements;
        for (var i = 0; i < deita.length; i++) {
            const e = deita[i] // Form element
            const name = e.name
            const value = e.value

            if (name && value)
                formData.append(name, value)
        }
        const file = this.fileInput.files[0]
        formData.append('MemberId', this.props.id)
        formData.append('file', file === undefined ? null : file)
        formData.append('type', 'docentschap')

        // TODO: Post payload to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {
                if (data !== undefined) {
                    Api.print(data)
                    this.setState({ errors: data });
                }
                else {
                    alert('Docentschap saved')
                    window.location.href = '/admin/leden/lid/kennis/' + this.props.id
                }
            })


    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="DocentschapNaamInstelling">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam Instelling
                    </Col>
                    <Col sm={6}>
                        <FormControl name="institution" type="text" required />
                        {Api.showError(errors, "nameOfInstitution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapNaamOpleiding">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam Opleiding
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" type="text" required />
                        {Api.showError(errors, "nameOfEducation")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapNiveau">
                    <Col componentClass={ControlLabel} sm={4}>
                        Niveau
                    </Col>
                    <Col sm={6}>
                        <FormControl name="level" componentClass="select" placeholder="">
                            <option value="">selecteer</option>
                            <option value="MBO/HBO">MBO/HBO</option>
                            <option value="Universitair">Universitair</option>
                        </FormControl>
                        {Api.showError(errors, "level")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>
                    <Col sm={6}>
                        <FormControl name="city" type="text" required />
                        {Api.showError(errors, "location")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapVanJaar">
                    <Col componentClass={ControlLabel} sm={4}>
                        Van jaar
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearInit" componentClass="select" required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "fromYear")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapTotJaar">
                    <Col componentClass={ControlLabel} sm={4}>
                        T/m jaar
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "toYear")}

                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapUrenPerJaar">
                    <Col componentClass={ControlLabel} sm={4}>
                        Uren per jaar
                    </Col>
                    <Col sm={6}>
                        <FormControl name="hours" type="text" required />
                        {Api.showError(errors, "hoursPerYear")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapActiviteiten">
                    <Col componentClass={ControlLabel} sm={4}>
                        Vak/Activiteiten
                    </Col>
                    <Col sm={6}>
                        <FormControl name="description" type="text" required />
                        {Api.showError(errors, "activities")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="DocentschapUpload">
                    <Col componentClass={ControlLabel} sm={4}>
                        Upload
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} required />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default Docentschap;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/Docentschap.js